module.exports = __webpack_public_path__ + "img/car-photo-05.b698899d.jpg";